/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Difficulty_HardInputs */

const bn_difficulty_hard = /** @type {(inputs: Difficulty_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কঠিন`)
};

const de_difficulty_hard = /** @type {(inputs: Difficulty_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hart`)
};

const el_difficulty_hard = /** @type {(inputs: Difficulty_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σκληρά`)
};

const en_difficulty_hard = /** @type {(inputs: Difficulty_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hard`)
};

const es_difficulty_hard = /** @type {(inputs: Difficulty_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duro`)
};

const fr_difficulty_hard = /** @type {(inputs: Difficulty_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Difficile`)
};

const hi_difficulty_hard = /** @type {(inputs: Difficulty_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुश्किल`)
};

const hu_difficulty_hard = /** @type {(inputs: Difficulty_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kemény`)
};

const id_difficulty_hard = /** @type {(inputs: Difficulty_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keras`)
};

const it_difficulty_hard = /** @type {(inputs: Difficulty_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Difficile`)
};

const ja_difficulty_hard = /** @type {(inputs: Difficulty_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`難しい`)
};

const ko_difficulty_hard = /** @type {(inputs: Difficulty_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`딱딱한`)
};

const nl_difficulty_hard = /** @type {(inputs: Difficulty_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moeilijk`)
};

const pl_difficulty_hard = /** @type {(inputs: Difficulty_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twardy`)
};

const pt_difficulty_hard = /** @type {(inputs: Difficulty_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duro`)
};

const ru_difficulty_hard = /** @type {(inputs: Difficulty_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жесткий`)
};

const sv_difficulty_hard = /** @type {(inputs: Difficulty_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hård`)
};

const tr_difficulty_hard = /** @type {(inputs: Difficulty_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zor`)
};

const uk_difficulty_hard = /** @type {(inputs: Difficulty_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`важко`)
};

const vi_difficulty_hard = /** @type {(inputs: Difficulty_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cứng`)
};

const zh_difficulty_hard = /** @type {(inputs: Difficulty_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`难的`)
};

const zh_hant_difficulty_hard = /** @type {(inputs: Difficulty_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`難的`)
};

/**
* | output |
* | --- |
* | "Hard" |
*
* @param {Difficulty_HardInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const difficulty_hard = /** @type {((inputs?: Difficulty_HardInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Difficulty_HardInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_difficulty_hard(inputs)
	if (locale === "de") return de_difficulty_hard(inputs)
	if (locale === "el") return el_difficulty_hard(inputs)
	if (locale === "en") return en_difficulty_hard(inputs)
	if (locale === "es") return es_difficulty_hard(inputs)
	if (locale === "fr") return fr_difficulty_hard(inputs)
	if (locale === "hi") return hi_difficulty_hard(inputs)
	if (locale === "hu") return hu_difficulty_hard(inputs)
	if (locale === "id") return id_difficulty_hard(inputs)
	if (locale === "it") return it_difficulty_hard(inputs)
	if (locale === "ja") return ja_difficulty_hard(inputs)
	if (locale === "ko") return ko_difficulty_hard(inputs)
	if (locale === "nl") return nl_difficulty_hard(inputs)
	if (locale === "pl") return pl_difficulty_hard(inputs)
	if (locale === "pt") return pt_difficulty_hard(inputs)
	if (locale === "ru") return ru_difficulty_hard(inputs)
	if (locale === "sv") return sv_difficulty_hard(inputs)
	if (locale === "tr") return tr_difficulty_hard(inputs)
	if (locale === "uk") return uk_difficulty_hard(inputs)
	if (locale === "vi") return vi_difficulty_hard(inputs)
	if (locale === "zh") return zh_difficulty_hard(inputs)
	return zh_hant_difficulty_hard(inputs)
});